import { render } from "./ExpensesView.vue?vue&type=template&id=5cbe5906&scoped=true"
import script from "./ExpensesView.vue?vue&type=script&lang=js"
export * from "./ExpensesView.vue?vue&type=script&lang=js"

import "./ExpensesView.vue?vue&type=style&index=0&id=5cbe5906&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbe5906"]])

export default __exports__